// ParticlePool.js
// Lightweight reusable particle pool to avoid GC churn.

class ParticlePool {
  constructor(max = 320) {
    this.max = max;
    this.particles = new Array(max).fill(null).map(() => this._create());
    this.cursor = 0;
  }

  _create() {
    return {
      active: false,
      x: 0,
      y: 0,
      vx: 0,
      vy: 0,
      size: 1,
      color: '#ffffff',
      aura: '#ffffff',
      alpha: 1,
      ttl: 1200,
      age: 0,
      type: 'star',
      glow: 0.6,
      group: 'global',
      sessionId: null,
      history: [],
      fadeOut: false,
      strength: 1,
      activityFade: 1,
    };
  }

  acquire(props = {}) {
    let particle =
      this.particles.find((p) => !p.active) ||
      this.particles[this.cursor % this.max];
    this.cursor = (this.cursor + 1) % this.max;

    Object.assign(particle, this._create(), props, {
      active: true,
      age: 0,
      history: [],
    });

    return particle;
  }

  forEachActive(fn) {
    for (let i = 0; i < this.particles.length; i += 1) {
      const p = this.particles[i];
      if (p.active) fn(p, i);
    }
  }

  clear() {
    this.particles.forEach((p) => {
      p.active = false;
      p.history = [];
    });
  }

  getParticles() {
    return this.particles;
  }
}

export default ParticlePool;
